// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../graphql/api/index';

import { gql } from 'graphql-tag';
import { QuestionnaireFragmentDoc } from '../components/cms/component/questionnaire/Questionnaire.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const QuestionnaireDocument = gql`
    query questionnaire($id: ID!, $locale: Locale!, $currency: CurrencyInput!, $country: CountryCode!) {
  questionnaire(id: $id) {
    ...questionnaire
  }
}
    ${QuestionnaireFragmentDoc}`;

export function useQuestionnaireQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.QuestionnaireQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.QuestionnaireQuery, SchemaTypes.QuestionnaireQueryVariables | undefined>({ query: QuestionnaireDocument, variables: undefined, ...options });
};